import { CombinedPriceLevel } from "../models/ui";
import { BoxOfficeActions, CategoryFormActions, PriceLevelActions } from "../actions"

export interface PricelevelState {
	combinedPricelevels: CombinedPriceLevel[];
};

const initialState: PricelevelState  = {
	combinedPricelevels: []
}


export const pricelevelReducer = (state = initialState, action) => {
	switch (action.type) {

		case PriceLevelActions.LOAD_PRICE_LEVEL_SUCCESS:
			return {
				combinedPricelevels:[...action.payload]
			}

		case CategoryFormActions.CATEGORY_AND_PRICELEVEL_SAVED:
			return {
				combinedPricelevels: action.payload.combinedPriceLevels
			}

		case CategoryFormActions.FORCE_DELETE_REDUCED_PRICELEVEL_SUCCESS: {
			let newCpl = [...state.combinedPricelevels]
			let cpl = newCpl.find(cpl => cpl.reduced.find(reduced => reduced.uuid === action.payload.uuid) != null)
			let reducedPriceLevel = cpl.reduced.find(reduced => reduced.uuid === action.payload.uuid)
			let index = cpl.reduced.indexOf(reducedPriceLevel)
			cpl.reduced.splice(index, 1)
			return {
				combinedPricelevels: newCpl
			}
		}

		case BoxOfficeActions.CLEAR_EVENTSERVER_STATE:
			return initialState;

		default: {
			return state;
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/reducers/pricelevel.reducer.ts